import styled from "styled-components";
import { HORIZONTAL_PADDING_PAGE_DEFAULT, MAX_WIDTH_PAGE } from '../../../../styles'

export const Wrapper = styled.div`
  padding-top: 24px;
  position: relative;

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding-top: 16px;
  }
`;

export const TitleSimilarProperties = styled.div`
  display: flex;
  margin: 0 auto 16px;
  padding: 0 ${HORIZONTAL_PADDING_PAGE_DEFAULT.SM};

  /* Horizontal padding must follow PropertiesGrid so the title lines up with the cards. */
  @media (min-width: 480px) and (max-width: 520px) {
    padding: 0 8px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 0 ${HORIZONTAL_PADDING_PAGE_DEFAULT.MD};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    max-width: ${MAX_WIDTH_PAGE};
    margin: 0 auto 24px;
  }
`;

export const DescriptionTitle = styled.h2`
  font-size: ${16 / 16}rem;
  font-family: "Inter", sans-serif;
  color: ${({ theme }) => theme.palette.greyscale.grey800};
  font-weight: 600;
  margin-right: auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${24 / 16}rem;
  }
`;

export const DescriptionParagraph = styled.p`
  font-size: ${14 / 16}rem;
  padding: 10px 0;
  color: ${({ theme }) => theme.palette.primary.blue500};
  font-family: "Inter", sans-serif;
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    width: ${16 / 16}rem;
    height: ${16 / 16}rem;
  }
`;

export const PropertiesGrid = styled.div`
display: grid;
box-sizing: border-box;
gap: 24px;
margin: 0 auto 24px;
padding: 0 ${HORIZONTAL_PADDING_PAGE_DEFAULT.SM};
width: 100%;
grid-template-columns: repeat(1, 1fr);

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileXs}){
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 480px) and (max-width: 520px) {
    padding: 0 8px;
    gap: 12px;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}){
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}){
    padding: 0 ${HORIZONTAL_PADDING_PAGE_DEFAULT.MD};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}){
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    grid-template-columns: repeat(4, 1fr);
  }

   @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    max-width: ${MAX_WIDTH_PAGE};
    margin: 0 auto 48px;
    grid-template-columns: repeat(5, 1fr);
  }

`;
